// extracted by mini-css-extract-plugin
export default {"textsWrapper":"ProfileMenu_textsWrapper__nAgKM","icon":"ProfileMenu_icon__a-FT-","avatar":"ProfileMenu_avatar__g0bLH"};